module.exports = __webpack_public_path__ + "img/Spring.81fbdd81.png";